module.exports = "data:application/vnd.ms-fontobject;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICI2NzRmNTBkMjg3YThjNDhkYzE5YmE0MDRkMjBmZTcxMy5lb3QiOw=="


//////////////////
// WEBPACK FOOTER
// ../~/font-awesome/fonts/fontawesome-webfont.eot
// module id = 1418
// module chunks = 0